
function SignIn({ signInWithGoogle }) {

    return (
        <button className="sign-in" onClick={signInWithGoogle}>Sign in with Google</button>
    )
}

export default SignIn
